<template lang="pug">
div(v-if='!hasError && quotePrice > 0' class='flex text-black')
  BaseFormCheckbox(v-model='hasWarranty' @click='toggleWarranty')
  div(class='ml-2')
    div(class='flex')
      img(src='/images/extend/logo.svg' width='57' height='14' alt='Extend')
      div(class='pl-2 font-bold') Shipping Protection - {{ formatCents(quotePrice) }}
    div(class='text-xs') Covers lost, stolen or damaged packages.
      |
      |
      a(class='underline text-black' @click='showPopup()') Learn More
</template>

<script setup lang="ts">
const { $extend, $uiEvents, $ketch } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
const notifications = useNotifications()
const log = useLogger('SHIPPING_PROTECTION')
const isWaiting = inject<Ref<boolean>>('isWaiting', ref(false))
const cart = useCart()

const quotePrice = ref(0)
const hasError = ref(false)
const hasUnchecked = useState('hasUncheckedShippingProtection', () => false)

onMounted(async () => {
  if (isIntegrationEnabled('ketch')) {
    $ketch.onConsentResolved(() => {
      if (!$ketch.hasConsent.value) {
        hasError.value = true
        return
      }
      loadExtend()
    })
  } else {
    loadExtend()
  }
})

watch(
  () => cart.state.value.total,
  () => {
    updatePrice()
  }
)

async function loadExtend() {
  await $extend.load()

  await waitUntilTrue(() => !!window.Extend && !!window.Extend.shippingProtection)
  // just so we can use the popup method.. ew
  if (!window.Extend.shippingProtection._instance) window.Extend.shippingProtection.render({ selector: '', items: [] })

  await updatePrice()

  if (cart.state.value.total < 50000 && hasUnchecked.value === false && !hasWarranty.value && quotePrice.value > 0)
    addWarranty(true)
}

function showPopup() {
  if (!window.Extend.shippingProtection._instance) return
  window.Extend.shippingProtection._instance.onClickLearnMore()
}

const hasWarranty = computed(() => {
  return cart.state.value.hasShippingProtection
})

function toggleWarranty() {
  if (hasWarranty.value) {
    removeWarranty()
    hasUnchecked.value = true
  } else addWarranty()
}

async function addWarranty(isAutoAdded = false) {
  isWaiting.value = true
  try {
    await cart.addShippingProtection()
    $uiEvents.$emit('addShippingProtection', isAutoAdded)
  } catch (error) {
    notifications.addError('Error', 'Failed to add shipping protection.  Please try again.')
  }

  isWaiting.value = false
}

async function removeWarranty() {
  isWaiting.value = true
  try {
    await cart.removeShippingProtection()
    $uiEvents.$emit('removeShippingProtection')
  } catch (error) {
    notifications.addError('Error', 'Failed to remove shipping protection.  Please try again.')
  }

  isWaiting.value = false
}

async function updatePrice() {
  try {
    quotePrice.value = await $extend.getShippingProtectionPrice(cart.state.value.items)

    // cart contains an ineligable item
    if (quotePrice.value === 0) return

    const protectionCartItem = await $extend.getShippingProtectionCartItem(cart.state.value.items)
    if (protectionCartItem) {
      const price = protectionCartItem.salePrice
      if (price != quotePrice.value) {
        console.log(
          `Extend shipping protection error: API price is ${quotePrice.value} but cart shows ${price}, fixed.`
        )
        quotePrice.value = price
      }
    }
  } catch (error) {
    log.error('updatePrice', { error })
    hasError.value = true
  }
}
</script>
<style>
.extend-shipping {
  padding: 0 !important;
}
</style>
